import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthServiceService } from '../../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from 'moment';

@Component({
  selector: 'app-subadmin-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class SubAdminNewsComponent implements OnInit {
  @ViewChild('UploadFileModal') uploadFileModal: TemplateRef<any>;
  news: any = [];
  order_detail: any;
  imgUrl = environment.ImageUrl;
  appUserId: any = null

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
    this.appUserId = this.local.getUser()?.id
    this.initData();
  }

  initData() {
    this.auth.shop_business_get_news(this.appUserId).subscribe(
      (response: any) => {
        this.news = response.body;
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  relevantNews: any = {
    currentPage: 1,
    lastPage: 1,
    data: [],
  };

  initNews(page: number = 1) {
    this.auth.get_bottom_banner({
      page: page,
      isPopular: 1,
      pageSize: 10
    }).subscribe(
      (response: any) => {
        this.relevantNews = response.body;
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }

  handleAddNews(id: any) {
    this.auth.shop_business_add_news({ bottomBannerId: id, shopId: this.appUserId }).subscribe(
      (response: any) => {
        this.toastr.success('News added successfully');
        this.initNews();
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }

  convertDate(value: number) {
    let date = value;

    return moment.unix(value).format('MMMM D, YYYY');
  }

  openModal(content: any) {
    this.modalService.open(content, {
      windowClass: 'upload_file_modal custom-width mt-5',
      // backdrop: 'static',
      keyboard: false,
      size: 'xs',
    });

    this.initNews();
  }

  handleEdit(data: any) {
    this.openModal(this.uploadFileModal);
  }

  handleDelete(id: any) {
    this.local
      .alertConfirm({ message: 'Are you sure you want to delete this news?' })
      .then((res: any) => {
        if (res.isConfirmed) {
          this.auth.shop_business_delete_news(id).subscribe(
            (response: any) => {
              this.toastr.success('Deleted successfully');
              this.initData();
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
        }
      });
  }
}
